<template>
    <van-skeleton avatar :row="1" v-if="List.length==0">{{List.length}}</van-skeleton>
    <div  v-else class="record-body">
        <List class="record" v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
            <CellGroup>
                <Cell center :title="item.title" v-for="(item,index) in List" :key="index">
                    <img :src="item.imgurl" slot="icon" alt="" @click="gotouch(item)">
                    <span slot="default">
                        <template v-if="item.state*1===0">
                            待审核
                        </template>
                        <template v-else>
                            奖励:<img :src="require('assets/img/common/coin.png')" class="coin" alt="">  {{item.score*1}}
                        </template>
                    </span>

                    <div slot="label">
                        <div>{{item.show_time}}</div>
                    </div>
                </Cell>
            </CellGroup>
        </List>
        <van-popup v-model="show" closeable :style="{ height: '100%',width: '100%' }" :close-icon="require('assets/img/common/colse.svg')">
            <video
              id="video" 
              class="video" 
              :src="mediaurl"
              controls = "true"
              :poster="imgurl"
              preload="auto" 
              webkit-playsinline="true" 
              playsinline="true"
              x-webkit-airplay="allow" 
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              style="object-fit:fill">
            </video> 
        </van-popup>
    </div>
</template>
<script>
    import {List, Cell, CellGroup,Popup} from 'vant'
    import './index.less'

    export default {
        name: "myChallenge",
        components: {
            List,
            Cell,
            CellGroup,
            vanPopup:Popup
        },
        data() {
            return {
                page: 1,
                List: [],
                finished: false,
                loading: false,
                show:false,
                imgurl:'',
                mediaurl:''
            }
        },
        methods: {
            showVideo: function (e) {
                window.location.href = e;
            },
            onLoad() {
                this.getList()
            },
            getList() {
                if (this.finished) return;
                this.$api.user.mycalories({page: this.page}).then((res) => {
                    if (res.status * 1 === 200) {
                        this.List = this.List.concat(res.data.list)
                        if (res.data.pages * 1 > this.page) {
                            this.page++
                        } else {
                            this.finished = true
                        }
                    }
                    this.loading = false
                })
            },
            gotouch(item) {
                this.show = true
                this.imgurl = item.imgurl
                this.mediaurl = item.mediaurl
                // var myVideo=document.getElementById("video");
                // myVideo.play();
                // if (myVideo.paused) 
                //   myVideo.play(); 
                // else 
                //   myVideo.pause(); 
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getList();
            })
        }
    }
</script>
